import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HubPage from "./pages/HubPage";
import CaseStudyPage from "./pages/CaseStudyPage";

function App() {
  // Force-remove the Emergent badge if the platform reinjects it.
  useEffect(() => {
    const kill = () => {
      document
        .querySelectorAll('#emergent-badge, a[href*="emergent.sh"][id*="badge"]')
        .forEach((el) => el.remove());
    };
    kill();
    const obs = new MutationObserver(kill);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HubPage />} />
          <Route path="/etudes-de-cas" element={<HubPage />} />
          <Route path="/etudes-de-cas/:slug" element={<CaseStudyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#121214",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
